export enum SwapPointType {
  SINGLE = 'single',
  DOUBLE = 'double',
}

export enum DelegationPointType {
  START = 'start',
  END = 'end',
}
